var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-nav-bar',{class:[
    'lld-rewrite-am-navbar-light',
    { 'back-banner-fixed': _vm.isFixed },
    _vm.not_iphonex ? 'notrem-lld-rewrite-am-navbar-light-notiphonex' : '',
    _vm.iphonex && !_vm.not_iphonex
      ? 'notrem-lld-rewrite-am-navbar-light-iphonex'
      : '' ],style:(_vm.bannerStyle),attrs:{"title":_vm.title,"left-arrow":_vm.defaultGoBack},on:{"click-left":_vm.bannerGoBack}})}
var staticRenderFns = []

export { render, staticRenderFns }